import React from "react";
import {
  FaReact,
  FaLaravel,
  FaGitAlt,
  FaGithub,
  FaNpm,
  FaFigma,
  FaBootstrap,
  
} from "react-icons/fa";
import {
  DiNodejs,
  DiAws,
  DiMysql,
  DiRedis,
  DiJava,
  DiRuby,
  DiPhp,
  DiJavascript1,
  DiCss3,
  DiHtml5,
  DiDotnet,
  DiCodeigniter,
  

} from "react-icons/di";
import {
  SiExpress,
  SiMariadb,
  SiCloudflare,
  SiDocker,
  SiPostman,
  SiVisualstudiocode,
  SiAndroidstudio,
  SiJfrog,
  SiStackoverflow,
  SiSentry,
  SiGooglecloud,
  SiJest,
  SiApache,
  SiCplusplus,
  SiSqlite,
  SiJquery,
  SiAngular,
  SiVuedotjs,
  SiSass,
  SiGulp,
  SiPython,
  SiMongodb,
  SiVercel,
  SiNextdotjs,
  SiThreedotjs,
  SiTailwindcss,
  SiExpo,
  SiRedux,
  SiTypescript,
  SiFirebase,
  SiCsharp,
  SiRust,
  SiDart,
  SiRubyonrails,
  SiSpringboot,
  SiDjango,
  SiKotlin,
  SiSwift,
  SiAndroid,
  SiIos,
  SiXamarin,
  SiFlutter,
  SiNativescript,
  SiWeb3Dotjs,
  SiMicrosoftsqlserver,
  SiPostgresql,
  SiIntellijidea,
  SiPycharm,
  SiGradle,
  SiApachemaven,
  SiVisualstudio,
  SiMysql,
  SiFilezilla,
  // SiWorkbench,
  SiZoho,
  SiZoom,
  // SiCsharp,
  SiDotnet
} from "react-icons/si";

const Skills = ({ skill }) => {
  const icon = {
    // Csharp: <SiCsharp />,
    Dotnet: <SiDotnet />,
    Zoho: <SiZoho />,
    Filezilla: <SiFilezilla />,
    Zoom:<SiZoom/>,
    Bootstrap: <FaBootstrap />,
    Codeigniter: <DiCodeigniter />,
    PHP: <DiPhp />,
    SQLite: <SiSqlite />,
    MySQL: <SiMysql />,
    Visualstudio: <SiVisualstudio />,
    Apachemaven: <SiApachemaven />,
    Gradle: <SiGradle />,
    Pycharm: <SiPycharm />,
    Intellijidea: <SiIntellijidea />,
    Postgresql: <SiPostgresql />,
    Microsoftsqlserver: <SiMicrosoftsqlserver />,
    Web3: <SiWeb3Dotjs />,
    NativeScript: <SiNativescript />,
    Flutter: <SiFlutter />,
    AndroidSDK: <SiAndroid />,
    Xamarin: <SiXamarin />,
    IOS: <SiIos />,
    Kotlin: <SiKotlin />,
    Swift: <SiSwift />,
    Dotnet: <DiDotnet />,
    Django: <SiDjango />,
    Springboot: <SiSpringboot />,
    Rubyonrails: <SiRubyonrails />,
    Dart: <SiDart />,
    Rust: <SiRust />,
    Csharp: <SiCsharp />,
    SQLite: <SiSqlite />,
    Docker: <SiDocker />,
    Postman: <SiPostman />,
    Jest: <SiJest />,
    Cloudflare: <SiCloudflare />,
    MariaDB: <SiMariadb />,
    Laravel: <FaLaravel />,
    VSCode: <SiVisualstudiocode />,
    AndroidStudio: <SiAndroidstudio />,
    JFrog: <SiJfrog />,
    Stackoverflow: <SiStackoverflow />,
    Sentry: <SiSentry />,
    GoogleCloud: <SiGooglecloud />,
    AWS: <DiAws />,
    Apache: <SiApache />,
    Redis: <DiRedis />,
    Cplusplus: <SiCplusplus />,
    MySQL: <DiMysql />,
    React: <FaReact />,
    Java: <DiJava />,
    Ruby: <DiRuby />,
    PHP: <DiPhp />,
    Jquery: <SiJquery />,
    Angular: <SiAngular />,
    Vue: <SiVuedotjs />,
    Sass: <SiSass />,
    Gulp: <SiGulp />,
    Python: <SiPython />,
    Javascript: <DiJavascript1 />,
    Node: <DiNodejs />,
    Express: <SiExpress />,
    MongoDb: <SiMongodb />,
    Git: <FaGitAlt />,
    Github: <FaGithub />,
    Npm: <FaNpm />,
    Figma: <FaFigma />,
    Bootstrap: <FaBootstrap />,
    Vercel: <SiVercel />,
    Firebase: <SiFirebase />,
    Css: <DiCss3 />,
    Html: <DiHtml5 />,
    Next: <SiNextdotjs />,
    Three: <SiThreedotjs />,
    Tailwind: <SiTailwindcss />,
    Expo: <SiExpo />,
    Redux: <SiRedux />,
    Typescript: <SiTypescript />,
  };

  return (
    <div 
      title={skill} 
      className="SkillBox" 
      aria-label={skill} 
      tabIndex="0" 
      role="img"
    >
      {icon[skill]}
    </div>
  );
};

export default Skills;

